"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarTranslations = void 0;
exports.calendarTranslations = {
    myCalendar: "My Calendar",
    myScheduleMap: "My Schedule Map",
    userScheduleMap: "{{name}}'s Schedule",
    completed: "Completed",
    projected: "Projected",
    schedule: "Schedule",
    travelMode: "Travel Mode",
    driving: "Driving",
    cycling: "Cycling",
    walking: "Walking",
    info: "Info",
    default: "Default",
    suggested: "Suggested",
    calendar: "Calendar",
    defaultRoute: "Default",
    suggestedRoute: "Suggested",
    selectDate: "Select Date",
    startLocation: "Start Location",
    endLocation: "End Location",
    addStartLocation: "Add Start Location",
    addEndLocation: "Add End Location",
    routeSettings: "Route Settings",
    noVisitsForDate: "No visits with location data for this date",
    loadingSchedule: "Loading schedule...",
    routeNotAvailable: "Route not available between the selected locations",
    visitConflict: "Conflict",
};
